module.exports = __webpack_public_path__ + "img/18_sp.537c01d2.gif";